enum AreaOfExpertiseGroupEnum {  
  Unknown = "unknown",
  PopulationByAge = "Populations Treated, Age",
  PopulationByGender = "Populations Treated, Gender",  
  PopulationByGroup = "Populations Treated, Group",  
  Procedures = "Procedures and Treatments Performed",  
  Conditions = "Conditions Treated"
}

export { AreaOfExpertiseGroupEnum }